import { ReduxState } from "Store/rootReducer";
import { useSelector } from "react-redux";
import { FindVehicleError } from "./interfaces";

export const findVehicleErrorSelector = (
  state: ReduxState,
): FindVehicleError | null => state.findVehicle.error;

export const useFindVehicleErrorSelector = (): FindVehicleError | null =>
  useSelector((state: ReduxState) => state.findVehicle.error);
